import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ToggleSwitchChangeEvent } from 'primeng/toggleswitch';
import { CouponCodeModel } from '../../../models/coupon.model';

@Component({
  selector: 'app-coupon-code',
  templateUrl: './coupon-code.component.html',
  styleUrl: './coupon-code.component.scss',
  standalone: false,
})
export class CouponCodeComponent {
  @Input() couponCode: CouponCodeModel;
  @Output() couponDeleted = new EventEmitter<CouponCodeModel>();
  @Output() couponEditRequested = new EventEmitter<CouponCodeModel>();
  @Output() couponActiveStateChanged = new EventEmitter<boolean>();

  constructor() {}

  public onCouponActiveStateChanged(event: ToggleSwitchChangeEvent): void {
    this.couponCode.isActive = event.checked;
    this.couponActiveStateChanged.emit(event.checked);
  }

  public onDeleteCoupon(): void {
    this.couponDeleted.emit(this.couponCode);
  }

  public onEditCoupon(): void {
    this.couponEditRequested.emit(this.couponCode);
  }

  public copyToClipboard(text: string): void {
    navigator.clipboard
      .writeText(text)
      .then(() => {})
      .catch(err => {
        console.error('Failed to copy text to clipboard', err);
      });
  }
}
